import { Injectable } from '@angular/core';
import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()
export class ParticipantUIState {
  constructor(
    private localePipe: WfLocalePipe
  ) {}
  typeCollection = [
    { text: this.localePipe.transform('component.participant.user'), value: 'wf.UserParticipantExpression' },
    { text: this.localePipe.transform('component.participant.variable'), value: 'wf.VariableParticipantExpression' },
    { text: this.localePipe.transform('component.participant.position'), value: 'wf.PositionParticipantExpression' },
    { text: this.localePipe.transform('component.participant.component'), value: 'wf.ComponentParticipantExpression' },
    { text: this.localePipe.transform('component.participant.reportingLine'), value: 'wf.ReportingLineParticipantExpression' },
    { text: this.localePipe.transform('component.participant.matrix'), value: 'wf.MatrixParticipantExpression' },
    { text: this.localePipe.transform('component.participant.activityExecutor'), value: 'wf.ActivityExecutorParticipantExpression' },
    { text: this.localePipe.transform('component.participant.organization'), value: 'wf.OrganizationParticipantExpression' }
  ];
}
